// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import _bindAll from 'lodash/bindAll';
import _throttle from 'lodash.throttle';
var FINISH_TIME_S = 0.3;
class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pos: props.pos || 0
    };
    this.slides_count = React.Children.count(props.children);
    _bindAll(this, ['on_scroll', 'on_resize']);
    this.on_resize = _throttle(this.on_resize, 100);
    this.animation = 0;
    this.pending_progress = null;
  }
  componentDidMount() {
    this.update_internals();
    window.addEventListener('resize', this.on_resize);
  }
  componentDidUpdate(prev_props) {
    var pos = this.props.pos;
    if (pos != prev_props.pos && this.state.pos != pos) this.scroll_to(pos);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.on_resize);
  }
  emit_scroll(progress) {
    if (this.pending_progress !== null) return;
    this.pending_progress = progress;
    window.requestAnimationFrame(() => {
      if (this.props.on_scroll) this.props.on_scroll(this.pending_progress);
      this.pending_progress = null;
    });
  }
  scroll_to(pos) {
    var tape = this.tape;
    var speed_x = 200;
    var offset_x = tape.scrollLeft;
    var start_offset_x = offset_x;
    var target_offset_x = tape.children[pos + 1].offsetLeft - this.filler_w;
    var dir = target_offset_x - start_offset_x;
    if (dir === 0) return void this.update_pos(pos);
    var acc = 2 * (target_offset_x - speed_x * FINISH_TIME_S - start_offset_x) / (FINISH_TIME_S * FINISH_TIME_S);
    var prev_t = performance.now();
    var animation = ++this.animation;
    var next = () => window.requestAnimationFrame(() => {
      if (animation !== this.animation) return;
      var t = performance.now();
      if (!isNaN(this.touch_offset_x)) return;else if (offset_x === target_offset_x) return void this.update_pos(pos);
      var d_t = (t - prev_t) / 1000;
      prev_t = t;
      offset_x += speed_x * d_t;
      speed_x += acc * d_t;
      if (dir > 0 && offset_x > target_offset_x || dir < 0 && offset_x < target_offset_x) {
        offset_x = target_offset_x;
      }
      tape.scrollLeft = offset_x;
      this.emit_scroll(offset_x / (this.max_scroll || this.tape.scrollWidth - this.tape_w));
      next();
    });
    next();
  }
  on_resize() {
    if (this.last_ww == window.innerWidth) return;
    this.last_ww = window.innerWidth;
    this.update_internals();
    var offset_x = this.tape.children[this.state.pos + 1].offsetLeft - this.filler_w;
    this.tape.scrollLeft = offset_x;
    this.emit_scroll(offset_x / this.max_scroll);
    this.pass_scroll = true;
    setTimeout(() => {
      this.pass_scroll = false;
      if (!this.scroll_queued) return;
      this.scroll_queued = false;
      this.on_scroll();
    }, 500);
  }
  on_scroll() {
    if (this.pass_scroll) return void (this.scroll_queued = true);
    var sl = this.tape.scrollLeft;
    var progress = sl / (this.tape.scrollWidth - this.tape.offsetWidth);
    this.emit_scroll(progress);
    var pos = Math.round(progress * this.slides_count - 0.49);
    pos = pos >= this.slides_count ? this.slides_count - 1 : pos;
    if (this.state.pos != pos) this.update_pos(pos);
  }
  update_internals() {
    this.width = this.el.offsetWidth;
    this.tape_w = this.tape.offsetWidth;
    this.filler_w = (this.tape_w - this.width) / 2;
    this.filler_start.style.width = this.filler_end.style.width = this.filler_w + 'px';
    this.max_scroll = this.tape.scrollWidth - this.tape_w;
  }
  update_pos(pos) {
    this.setState({
      pos
    });
    if (this.props.on_pos_update) this.props.on_pos_update(pos);
  }
  render() {
    var cls = cn(this.props.className, 'slider');
    return /*#__PURE__*/React.createElement("div", {
      className: cls,
      ref: el => this.el = el
    }, /*#__PURE__*/React.createElement("div", {
      className: "slider-tape",
      ref: t => this.tape = t,
      onScroll: this.on_scroll
    }, /*#__PURE__*/React.createElement("div", {
      className: "slider-filler_start",
      ref: f => this.filler_start = f
    }), this.props.children, /*#__PURE__*/React.createElement("div", {
      className: "slider-filler_end",
      ref: f => this.filler_end = f
    })));
  }
}
export { Slider };